module.exports = __webpack_public_path__ + "static/media/warehouse.b9495126.svg";